import Flex from "../Flex/Flex";
import Button from "../forms/Button/Button";
import InputNumber from "../forms/InputNumber/InputNumber";
import { usePrinterContext } from "@/contexts/PrinterContext";
import { useEffect, useState } from "react";
import { ProductCondition } from "@boxem/core-api-schema";
import { Modal, ModalBody, ModalHeader } from "../Modal/Modal";
import base64FNSKULabelPdf from "@/contexts/pdf/fnsku-label-generation";
import { productConditionToString } from "@/app/fba/utils";

export type FNSKULabelModalItem = {
  quantity: number; // if we're in a box, quantity in box, if we're not, quantity in shipment. (max 1000)
  fnsku: string;
  productName: string;
  productCondition: ProductCondition;
  expirationDate?: string;
};

export interface PrintFNSKULabelsModalProps {
  item?: FNSKULabelModalItem;
  onClose: () => void;
}

export default function PrintFNSKULabelsModal(props: PrintFNSKULabelsModalProps) {
  const { printFNSKULabel, submitJobInProgress } = usePrinterContext();

  const [fnskuBase64, setFNSKUBase64] = useState<string>();
  const [fnskuLabelCount, setFNSKULabelCount] = useState<number>(1);
  useEffect(() => {
    if (props.item) {
      const base64 = base64FNSKULabelPdf(
        null,
        props.item.fnsku,
        props.item.productName,
        productConditionToString(props.item.productCondition),
        1,
        props.item.expirationDate
      );
      setFNSKUBase64(base64.data);

      if (props.item.quantity > 1000) {
        // @TODO perhaps show an alert or something that we're truncating the amount
        return setFNSKULabelCount(1000);
      } else {
        return setFNSKULabelCount(props.item.quantity);
      }
    }
  }, [props.item]);

  if (!props.item) {
    return <></>;
  }

  return (
    <Modal
      open={!!props.item}
      onOpenChange={(open => {
        if (!open) props.onClose();
      })}
    >
      <ModalHeader>
        <h3>How many FNSKU labels would you like to print?</h3>
      </ModalHeader>

      <ModalBody>

        {fnskuBase64 && (
          <embed
            width="100%"
            style={{marginBottom:"1rem"}}
            src={"data:application/pdf;base64," + fnskuBase64}
            type="application/pdf"
          >
          </embed>
        )}

        <Flex justify="space-between" align="center" gap={2}>
          <Button size="large" type="secondary" onClick={() => props.onClose()}>
            Cancel
          </Button>

          <Flex align="center" gap={2}>
            <InputNumber
              style={{ width: "12rem" }}
              min={1}
              max={1000}
              value={fnskuLabelCount}
              onChange={e => setFNSKULabelCount(e)}
            />
            <Button
              size="large"
              disabled={submitJobInProgress}
              onClick={() => {
                printFNSKULabel(
                  props.item.fnsku,
                  props.item.productName,
                  props.item.productCondition,
                  fnskuLabelCount,
                  props.item.expirationDate,
                );

                props.onClose();
              }}
            >
              Print Labels ({fnskuLabelCount})
            </Button>
          </Flex>
        </Flex>
      </ModalBody>
    </Modal>
  );
}
